document.addEventListener('DOMContentLoaded', () => {
    const liveChatLinks = document.querySelectorAll('[href="#live-chat"]');


    liveChatLinks.length && liveChatLinks.forEach(liveChatLink => {
        liveChatLink.addEventListener('click', e => {
            e.preventDefault();

            const liveChat = document.querySelector('.circleRollButton');

            if (liveChat) liveChat.click();
        });
    });
});